import { DatePost } from '../../ui/elements/DatePost'
import { FireDot } from '../../ui/icons/shared'

export function PostDetailsHeader({ post }) {
  const formattedDate = new Date(post.createdAt).toLocaleDateString('he-IL', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })

  return (
    <article
      className="relative flex flex-col gap-[40px] items-start sm:items-center"
      aria-label={`פרטי כתבה: ${post.title}`}
    >
      <header className="w-full mx-auto p-2">
        {post.imageUrl && (
          <div
            className="w-full aspect-[16/9] mb-6"
            aria-label="תמונת נושא של הפוסט"
          >
            <img
              src={post.imageUrl}
              alt={`תמונה מתוך הפוסט: ${post.title}`}
              title={post.title}
              className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
              srcSet={`${post.imageUrl}?w=800 800w, ${post.imageUrl}?w=1200 1200w`}
              sizes="(max-width: 768px) 100vw, 730px"
            />
          </div>
        )}

        <div
          className="flex justify-start items-center gap-7 my-[30px]"
          aria-label={`פורסם בתאריך: ${formattedDate}`}
        >
          <DatePost formattedDate={formattedDate} />

          <div className="flex items-center gap-3">
            {post.isNew && (
              <h4
                className="text-h4 text-primary"
                aria-label="מאמר חדש באתר"
                title="חדש באתר"
              >
                חדש באתר!
              </h4>
            )}
            {post.spoilerWarning && (
              <h4
                className="text-h4 text-primary"
                aria-label="כולל אזהרת ספוילר"
                title="אזהרת ספוילר"
              >
                אזהרת ספוילר
              </h4>
            )}
          </div>
        </div>

        <div
          className="text-right max-w-[660px]"
          aria-label="כותרת ותקציר הפוסט"
        >
          <h1
            className="text-h1 mb-4"
            title={post.title}
            aria-label={`כותרת הפוסט: ${post.title}`}
          >
            {post.title}
          </h1>
          <p
            className="text-p max-w-[600px]"
            aria-label={`תיאור קצר: ${post.description}`}
            title={post.description}
          >
            {post.description}
          </p>
        </div>
      </header>
    </article>
  )
}
